import React from 'react';
import * as XLSX from 'xlsx';

const MachineBreakdownHistory = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const breakdownData = inspectionData.MachineBreakdownHistory;

  if (!breakdownData || !breakdownData.sections) {
    return <p className="text-gray-500">No Machine Breakdown History data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Date',
      'Line',
      'Machine',
      'From',
      'To',
      'Issue',
    ]);

    // Populate data for each section
    breakdownData.sections.forEach((section) => {
      worksheetData.push([
        breakdownData.date,
        section.line,
        section.machine,
        section.from,
        section.to,
        section.issue,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'MachineBreakdown');
    XLSX.writeFile(workbook, 'MachineBreakdownHistoryData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Machine Breakdown History - {breakdownData.date}
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded-lg">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left text-gray-700">Line</th>
              <th className="px-4 py-2 text-left text-gray-700">Machine</th>
              <th className="px-4 py-2 text-left text-gray-700">From</th>
              <th className="px-4 py-2 text-left text-gray-700">To</th>
              <th className="px-4 py-2 text-left text-gray-700">Issue</th>
            </tr>
          </thead>
          <tbody>
            {breakdownData.sections.map((section, index) => (
              <tr key={index} className="border-t">
                <td className="px-4 py-2 text-gray-600">{section.line || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{section.machine || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{section.from || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{section.to || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{section.issue || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MachineBreakdownHistory;